import React from "react";

const MicStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 6.25C7 4.45507 8.4551 3 10.25 3C12.0449 3 13.5 4.45507 13.5 6.25V9.25C13.5 11.0449 12.0449 12.5 10.25 12.5C8.4551 12.5 7 11.0449 7 9.25V6.25Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 11C4 11 4.25 15.5 10.25 15.5C16.25 15.5 16.5 11 16.5 11",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.25 16V17.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MicStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;